<template>
  <div class="row mt-3">
    <div class="col-md-12">
      <div class="section-header">
        <h3>MTN Mobile Money</h3>
        <p class="text-muted font-weight-light">
          Opérations et services Mobile Money
        </p>
      </div>
    </div>

    <ServiceCard
      :key="index"
      v-for="(item, index) in items.slice(0, 4)"
      :description="item.description"
      :title="item.title"
      :link_type="item.link_type"
      :extern_link="item.extern_link"
      :url="item.url"
      :modal_id="item.action"
    />

    <div class="col-md-12 see-more">
      <SeeMoreBtn :btn_class="'float-right'" :path="'/momo/'" />
    </div>
  </div>
</template>

<script>
import ServiceCard from "@/components/utils/ServiceCard";
import SeeMoreBtn from "@/components/utils/SeeMoreBtn";

export default {
  components: { ServiceCard, SeeMoreBtn },
  name: "HomeSimBox",
  data: function () {
    return {
      // items: this.utils_get_config_item("mobile_money"),
      items: [
        {
          title: "Code PIN Mobile Money",
          description: "Réinitialiser mon code PIN Mobile Money",
          link_type: "btn",
          action: "code_momo",
          url: "",
          extern_link: false,
        },
        {
          title: "Transfert d'agent",
          description: "Transférer de l'agent à un proche",
          link_type: "btn",
          action: "comming_soon_popup",
          url: "",
          extern_link: false,
        },
        {
          title: "MomoPay",
          description: "Payer vos produits à travers momopay en quelques clics",
          link_type: "btn",
          action: "comming_soon_popup",
          url: "",
          extern_link: false,
        },
        {
          title: "Abonnement Canal+",
          description: "Réabonnez vous à Canal+ en quelques clics",
          link_type: "btn",
          action: "comming_soon_popup",
          url: "",
          extern_link: false,
        },
        {
          title: "Momo SBEE",
          description: "Achetez du crédit pour vos compteurs prépayés",
          link_type: "btn",
          action: "comming_soon_popup",
          url: "",
          extern_link: false,
        },
      ],
    };
  },
  mounted: async function () {},
  methods: {},
};
</script>
<style scoped lang="css">
.see-more {
  margin-top: -30px !important;
}
@media only screen and (max-width: 600px) {
  .see-more {
    margin-top: 0 !important;
  }
}
</style>
